import React, { useState, useEffect, useCallback } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import editImage from "../../assets/images/icons/edit-2.svg";
import DeleteIcon from "../../assets/images/icons/delete-w.svg";
import Cuisine from "../../assets/images/img.webp";
import { Link, useNavigate } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { UI_CONSTANTS } from "../../utils/constants";
import TablePagination from "../../commons/Pagination/TablePagination";

function DishCategories() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit] = useState(5);
  const [totalPages, setTotalPages] = useState(1);

  const getList = useCallback(async () => {
    setLoading(true);
    try {
      const query = new URLSearchParams({
        page,
        limit,
        ...(search && { search }),
      }).toString();

      const response = await handleApiCall("get", `${endpoints.dishCategoryList}?${query}`);
      if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        setData(response?.data?.data?.data || []);
        setTotalPages(response?.data?.data?.pagination?.totalPages || 1);
      }
    } catch (error) {
      console.error("Error fetching dish categories:", error);
    } finally {
      setLoading(false);
    }
  }, [page, limit, search]);

  useEffect(() => {
    getList();
  }, [getList]);

  // Reset page to 1 when search changes
  useEffect(() => {
    setPage(1);
  }, [search]);

  const block = async (status, id) => {
    try {
      const response = await handleApiCall("patch", `${endpoints.dishCategoryBlock}/${id}`, {
        status,
      });
      if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        toast.success(response?.data?.message || UI_CONSTANTS.TOAST_MESSAGES.SUCCESS.STATUS_UPDATED);
        getList();
      }
    } catch (error) {
      console.error("Error dish category:", error);
      // Network errors are already handled by handleApiCall
    }
  };

  const deleteDishCategory = async (id) => {
    if (window.confirm(UI_CONSTANTS.CONFIRMATION_MESSAGES.DELETE_DISH_CATEGORY)) {
      try {
        const response = await handleApiCall("delete", `${endpoints.dishCategoryDelete}?dishCategoryId=${id}`);
        if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
          toast.success(UI_CONSTANTS.TOAST_MESSAGES.SUCCESS.DISH_CATEGORY_DELETED);
          getList();
        }
      } catch (error) {
        console.error("Error dish category:", error);

        // Network errors are already handled by handleApiCall
      }
    }
  };

  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">{UI_CONSTANTS.PAGE_TITLES.DISH_CATEGORIES}</h3>
            </div>
            <div className="mb-4 px-0 py-2">
              <div className="card-heading d-flex align-items-center mb-3 pb-2">
                <div className="d-flex align-items-center col-md-12 px-0">
                  <form className="col-md-3 px-0">
                    <div className="form-group my-0">
                      <input
                        className="form-control search-icon left-icon border"
                        placeholder={UI_CONSTANTS.PLACEHOLDERS.SEARCH}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </div>
                  </form>
                  <button onClick={() => navigate(UI_CONSTANTS.ROUTES.ADD_DISH)} className="ml-auto btn btn-primary">
                    {UI_CONSTANTS.BUTTON_LABELS.ADD_NEW}
                  </button>
                </div>
              </div>
              <div className="col-md-12 tab-content row px-0 mx-0">
                <div className="table-responsive px-0">
                  <table className="table table-striped trim">
                    <thead>
                      <tr>
                        <th width="80" class="text-center">
                          {UI_CONSTANTS.TABLE_HEADERS.ID}
                        </th>
                        <th width="150">{UI_CONSTANTS.TABLE_HEADERS.NAME}</th>
                        <th>{UI_CONSTANTS.TABLE_HEADERS.STATUS}</th>
                        <th className="text-center">{UI_CONSTANTS.TABLE_HEADERS.ACTIONS}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="4" className="text-center py-4">
                            {UI_CONSTANTS.BUTTON_LABELS.LOADING}
                          </td>
                        </tr>
                      ) : data.length > 0 ? (
                        data.map((category, index) => (
                          <tr key={category._id || index}>
                            <td>{(page - 1) * limit + index + 1}</td>
                            <td className="text-center">{category.name || "N/A"}</td>
                            <td>
                              <label className="custom-control custom-switch p-1 ml-4 mb-0 mt-1" role="button">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  checked={category.status === 1}
                                  onChange={() => block(category.status === 1 ? 0 : 1, category._id)}
                                />
                                <span className="custom-control-label custom-toggle" />
                              </label>
                            </td>
                            <td>
                              <div className="d-flex align-items-center justify-content-center">
                                <button
                                  onClick={() => {
                                    // Store dish category data in localStorage for the edit page
                                    localStorage.setItem(UI_CONSTANTS.LOCAL_STORAGE_KEYS.SELECTED_DISH_CATEGORY, JSON.stringify(category));
                                    window.location.href = `${UI_CONSTANTS.ROUTES.EDIT_DISH}/${category._id}`;
                                  }}
                                  className="btn btn-link p-0 mx-2"
                                >
                                  <img src={editImage} alt={UI_CONSTANTS.BUTTON_LABELS.EDIT} className="mr-2" />
                                </button>
                                {/* <button onClick={() => deleteDishCategory(category._id)} className="btn btn-link p-0">
                                  <img src={DeleteIcon} alt={UI_CONSTANTS.BUTTON_LABELS.DELETE} />
                                </button> */}
                              </div>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center py-4">
                            {UI_CONSTANTS.EMPTY_STATES.NO_DATA_FOUND}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              <TablePagination page={page} totalPages={totalPages} onPageChange={setPage} />

            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DishCategories;
